import { render, staticRenderFns } from "./wallet-record.vue?vue&type=template&id=3e9c15c6&scoped=true&"
import script from "./wallet-record.vue?vue&type=script&lang=js&"
export * from "./wallet-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9c15c6",
  null
  
)

export default component.exports